// extracted by mini-css-extract-plugin
module.exports = {"selector":"styles_selector__2s7j-"};